import { AGENT_CAPABILITY_DEFAULTS, AgentCapability, } from '../types/agentPermissions';
export const AGENT_CAPABILITY_SCOPES = {
    [AgentCapability.ReadDiscover]: 'view:AgentReadDiscover',
    [AgentCapability.Query]: 'view:AgentQuery',
    [AgentCapability.RawSql]: 'view:AgentRawSql',
    [AgentCapability.ContentWrite]: 'view:AgentContentWrite',
    [AgentCapability.Delete]: 'view:AgentDelete',
    [AgentCapability.Publish]: 'view:AgentPublish',
    [AgentCapability.DeployUpload]: 'view:AgentDeployUpload',
    [AgentCapability.DbtWriteback]: 'view:AgentDbtWriteback',
    [AgentCapability.Export]: 'view:AgentExport',
    [AgentCapability.Administration]: 'view:AgentAdministration',
    [AgentCapability.ExternalTools]: 'view:AgentExternalTools',
};
export const AGENT_SCOPE_CAPABILITIES = Object.fromEntries(Object.entries(AGENT_CAPABILITY_SCOPES).map(([capability, scope]) => [
    scope,
    capability,
]));
export const AGENT_CAPABILITY_SUBJECTS = Object.values(AGENT_CAPABILITY_SCOPES).map((scope) => scope.slice('view:'.length));
export const AGENT_DEFAULT_CAPABILITY_SUBJECTS = AGENT_CAPABILITY_DEFAULTS.map((capability) => AGENT_CAPABILITY_SCOPES[capability].slice('view:'.length));
//# sourceMappingURL=agentCapabilityScopes.js.map